
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/digital",
      function () {
        return require("private-next-pages/products/digital/index.tsx");
      }
    ]);
  